module.exports = __webpack_public_path__ + "assets/img/4109d35a176384252adcbbf24e14f307.png";